import { render, staticRenderFns } from "./FrequencyChart.vue?vue&type=template&id=a44d76de&scoped=true&"
import script from "./FrequencyChart.vue?vue&type=script&lang=js&"
export * from "./FrequencyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d76de",
  null
  
)

export default component.exports